module.exports = __webpack_public_path__ + "static/edit_content_395x272-ae524d1a2878695d120259a0c2b8eddb.webp";